import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";

//charts
import { Line, defaults } from 'react-chartjs-2';


class Shortlist extends Component {

    constructor(props) {
        super(props);

    }
    componentDidMount() {
        // This method is called when the component is first added to the document

        this.ensureDataFetched();

    }

    componentDidUpdate() {
        // This method is called when the route parameters change
        //this.ensureDataFetched();
    }

    ensureDataFetched() {
     //   const shortlistID = this.props.match.params.shortlistID;
        // this.props.requestWeatherForecasts(startDateIndex);
   //     this.props.getShortList(shortlistID);

    }

    reorder(list, startIndex, endIndex) {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    moveSingleTrack(e) {
        var asset = this.props.tempShortList.filter(t => t.code == e.dataTransfer.getData("text"));
        if (asset != null) {
            this.props.AddSingeAssetToShortList(asset[0]);
        }
    }

    selectTrack(e) {

      //  var track = this.props.assetSearchList.filter(a => a.code == e.target.value);
        this.props.selectTrack(e.target.value);
    }

    goUp(data) {

        let index;
        if (data.target) {
            index = parseInt(data.target.value);
        } else {
            index = parseInt(data);
        }


        let items = this.reorder(
            this.props.tempShortList,
            index,
            index == 0 ? 0 : index - 1
        );
        console.info(items);

        this.props.sortTempTracks(items);
      //  this.props.updateShortList();
    }

    goDown(data) {

        let index;

        if (data.target) {
            index = parseInt(data.target.value);
        } else {
            index = parseInt(data);
        }

        let items = this.reorder(
            this.props.tempShortList,
            index,
            index === this.props.tempShortList.length - 1 ? index : index + 1
        );
        console.info(items);

        this.props.sortTempTracks((items));
        //this.props.updateShortList();
    }

    onDragStart(e, id) {
        console.info(e + id);
        e.dataTransfer.setData("text", id);
    }

    onDragEnd(result) {
        console.info(result);
        if (!result.destination) {
            console.info("houston");
            return;
        }

        console.info(result.source.index);
        console.info(result.destination.index);
        let items = this.reorder(
            this.props.tempShortList,
            result.source.index,
            result.destination.index == -1 ? 0 : result.destination.index
        );
        console.info(items);

        this.props.sortTempTracks(items);
       // this.props.updateShortList();

    }

    onNameChange(e) {
        this.props.SetShortlistName(e.target.value);
    }

    renderShortListItems() {
        let data;


        data = this.props.shortlistDetail.assets;



        return <table onDragOver={(e) => e.preventDefault()} onDrop={(e) => this.moveSingleTrack(e)} className='table table-hover search'>
            <thead>
                <tr>
                    <th>#</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>ISRC</th>
                    <th>Catalog</th>
                    <th>Name</th>
                    <th>Artist</th>
                    <th>Genre</th>
                    <th>Sub Genre</th>
                    <th>Audio</th>
                    <th>$</th>
                    <th>version</th>
                    <th>Territory</th>
                    <th>LoP</th>
                    <th>Exclusive</th>
                    <th>Use</th>
                    <th>Select</th>
                </tr>
            </thead>
            <tbody>
                {
                    this.props.shortlistDetail ? data.map((product, index) =>
                        <tr key={product.code}>
                            <td>{index + 1}</td>
                            <td><Link to={this.props.match.params.SearchType === "product" ? '/product/' + product.code : '/detail/asset/' + product.code}><span className='glyphicon glyphicon-search'></span></Link></td>
                            <td><span className='glyphicon glyphicon-arrow-up' value={index} onClick={() => this.goUp(index)} ></span></td>
                            <td><span className='glyphicon glyphicon-arrow-down' value={index} onClick={() => this.goDown(index)}></span></td>
                            <td>{product.code}</td>
                            <td>{product.catalog}</td>
                            <td>{product.name}</td>
                            <td>{product.displayArtist}</td>
                            <td>{product.genre}</td>
                            <td>{product.subGenre}</td>
                            <td> {/* <CircleMediaPlayer src={"/api/charts/getaudio?fugaid=" + product.fugaId} />*/}</td>
                            <td>{product.financial}</td>
                            <td>{product.version}</td>
                            <td>{product.territories}</td>
                            <td>{product.languagePerformance === "ZXX" ? "Ins" : product.languagePerformance}</td>
                            <td>{product.exclusive}</td>
                            <td>{product.productCount === 0 ? "Inactive" : product.productCount < 5 ? "Active" : "Hyper"}</td>
                            <td>{this.props.removeShortList.filter(t => t.code === product.code).length > 0 ? <span className='glyphicon glyphicon-ok-sign' value={index} onClick={() => this.shortListSelectTrack(product.code)} ></span> : <span className='glyphicon glyphicon-remove-sign' value={index} onClick={() => this.shortListSelectTrack(product.code)} ></span>}

                            </td>



                        </tr>
                    )
                        : []}

            </tbody>
        </table>;
    }
    renderForecastsTable() {
        let data;
        data = this.props.tempShortList;
        return <table className='table table-hover search'>
            <thead>
                <tr>
                    <th>#</th>
                    <th>ISRC</th>
                    <th>Catalog</th>
                    <th>Name</th>
                    <th>Artist</th>
                    <th>Genre</th>
                    <th>Sub Genre</th>
                    <th>Audio</th>                   
                    <th>version</th>                   
                    <th>LoP</th>                   
                    <th>Use</th>
                    <th></th>
                    <th></th>
                    <th>Short Listed</th>
                </tr>
            </thead>
            <tbody>
                {
                    !this.props.isLoadingSearchList ? data.map((product, index) =>
                        <tr draggable onDragStart={(e) => this.onDragStart(e, product.isrc)} onDragEnd={(e) => this.onDragEnd(e, product.isr)} onDragOver = {(e) => e.preventDefault()} key={product.isrc}>
                            <td>{index+1}</td>
                            <td>{product.isrc}</td>
                            <td>{product.catalog}</td>
                            <td>{product.name}</td>
                            <td>{product.displayArtist}</td>
                            <td>{product.genre}</td>
                            <td>{product.subGenre}</td>
                            <td> <button onClick={() => this.props.setAudioUrl(product.fugaID)}> {this.props.audioURL === product.fugaID ? "Playing" : "Play"}</button> </td>                          
                            <td>{product.version}</td>                          
                            <td>{product.lop == "ZXX" ? "Ins" : product.lop}</td>                         
                            <td>{product.productCount == 0 ? "Inactive" : product.productCount < 5 ? "Active" : "Hyper"}</td>
                            <td><span className='glyphicon glyphicon-arrow-up' value={index} onClick={() => this.goUp(index)} >up</span></td>
                            <td><span className='glyphicon glyphicon-arrow-down' value={index} onClick={() => this.goDown(index)}>down</span></td>
                            <td><button className='btn btn-default' value={product.isrc} onClick={this.selectTrack.bind(this)}> {this.props.tempShortList.filter(t => t.isrc === product.isrc).length > 0 ? '√' : 'X'} </button></td>

                        </tr>
                    )
                        : []}

            </tbody>
        </table>;
    }

    createShortList(e) {
        this.props.CreateShortList();
    }

    clearShortList() {
        this.props.clearShortList();
    }
    render() {
        const access = localStorage.getItem("accessToken");
        console.info(this.props.audioURL);
        let url = this.props ? this.props.audioURL : '';
        return (
            <div>
                <h1>Product Assets</h1>

                <div className="container">
                    <div className="row">
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="shortListTitle" placeholder={"Shortlist name"} onChange={(e) => this.onNameChange(e)} value={this.props.shortListName}></input>
                            
                        </div>
                        <div className="col-sm-3">
                            <button disabled={this.props.shortListName === '' || this.props.isSavingAssetsToShortList || this.props.tempShortList == null || this.props.tempShortList.length == 0} onClick={(e) => this.createShortList(e)}>Save</button></div>
                        <div className="col-sm-3">
                            <button disabled={this.props.tempShortList == null || this.props.tempShortList.length == 0} onClick={(e) => this.clearShortList()}>Clear</button></div>
                    </div>
               
                    <br/>
                    <div className="row">
                        <div className="col-sm-12">
                            {this.props.tempShortList != null && this.props.tempShortList.length > 0 ? this.renderForecastsTable() : ''}
                        </div>
                    </div>

                </div>
            </div>
              
        );
    }
}








export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Shortlist);



// WEBPACK FOOTER //
// ./src/components/shortlist.js